/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryTransferCommandResult } from '../../models/create-inventory-transfer-command-result';

export interface ApiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Params {
      body?: {
'SourceStore'?: string;
'DestinationStore'?: string;
'Quantity'?: number;
'ItemId'?: string;
}
}

export function apiNurseryManagerInventoryCreateInventoryTransferPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryTransferCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryCreateInventoryTransferPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateInventoryTransferCommandResult>;
    })
  );
}

apiNurseryManagerInventoryCreateInventoryTransferPost$Plain.PATH = '/api/NurseryManager/Inventory/CreateInventoryTransfer';
